import { render, staticRenderFns } from "./CustomerLogs.vue?vue&type=template&id=7c00995a&"
import script from "./CustomerLogs.vue?vue&type=script&lang=js&"
export * from "./CustomerLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports